import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchActiveUsers, revokeUserAllTokens, revokeUserToken } from "../api/activeUsersApi";

export const activeUsersKeys = {
  all: ["active-users"] as const,
};

export const useActiveUsersQuery = () =>
  useQuery({
    queryKey: activeUsersKeys.all,
    queryFn: fetchActiveUsers,
    refetchInterval: 60_000,
  });

export const useRevokeUserToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: revokeUserToken,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: activeUsersKeys.all });
    },
  });
};

export const useRevokeUserAllTokens = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: revokeUserAllTokens,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: activeUsersKeys.all });
    },
  });
};
